import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  // 원페이지 랜딩 (공식 홈페이지와 별개의 독립 랜딩)
  {
    path: '/landing',
    name: 'landing',
    component: () => import('../views/LandingView.vue')
  },
  // 사업소개 (탭: 사업개요, 브랜드)
  {
    path: '/intro/:sub',
    name: 'intro',
    component: () => import('../views/web/intro/IntroView.vue')
  },
  // 입지안내
  {
    path: '/location/environment',
    name: 'location',
    component: () => import('../views/web/location/LocationView.vue')
  },
// 상품안내 (탭: 단지정보, 프리미엄, 커뮤니티)
  {
    path: '/product/:sub',
    name: 'product',
    component: () => import('../views/web/product/ProductView.vue')
  },
  // 세대안내 (84, 59A, 59B)
  {
    path: '/type/:size',
    name: 'type',
    component: () => import('../views/web/type/TypeView.vue')
  },
  // 홍보센터 (이벤트, 이벤트 당첨자)
  {
    path: '/media/:sub',
    name: 'media',
    component: () => import('../views/web/media/MediaView.vue')
  },
  // 방문예약
  {
    path: '/reservation/register',
    name: 'reservation',
    component: () => import('../views/web/ReservationView.vue')
  },
  // 오시는길
  {
    path: '/reservation/location',
    name: 'reservation-location',
    component: () => import('../views/web/reservation/DirectionsView.vue')
  },
  // 개인정보처리방침
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('../views/web/PrivacyView.vue')
  },
  // 관리자
  {
    path: '/admin',
    name: 'admin',
    component: () => import('../views/admin/AdminView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

// 모비온 원태그 - SPA 페이지 이동 시 데이터매니저 호출
window['callDM'] = window['callDM'] || function () {
  (window['callDM'].q = window['callDM'].q || []).push(arguments)
}

router.afterEach(() => {
  window.callDM()
  // 네이버 로그분석 - SPA 페이지 전환 시 PV 전송
  if (window.wcs) {
    if (!window.wcs_add) window.wcs_add = {}
    window.wcs_add['wa'] = 's_248a9401d7df'
    window.wcs.inflow()
    window.wcs_do()
  }
})

export default router
